<template>
  <button class="like" :class="{ on: liked, pop }" type="button"
    :aria-pressed="liked ? 'true' : 'false'" :title="$t('im.like')"
    @click.stop.prevent="toggle">
    <span class="disc">
      <svg viewBox="0 0 512 512" aria-hidden="true">
        <path d="M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z"/>
      </svg>
    </span>
    <span class="count">{{ total }}</span>
  </button>
</template>

<script>
import likes from '@/likes';

export default {
  name: 'LikeButton',
  props: {
    pid: { type: String, required: true },
    count: { type: Number, default: 0 },
  },
  data() {
    return { pop: false };
  },
  computed: {
    liked() {
      return likes.isLiked(`im:${this.pid}`);
    },
    total() {
      return this.count + (this.liked ? 1 : 0);
    },
  },
  methods: {
    toggle() {
      likes.toggle(`im:${this.pid}`);
      this.pop = false;
      // restart the animation
      this.$nextTick(() => {
        this.pop = true;
        setTimeout(() => { this.pop = false; }, 450);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.like {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 4px;
  font-size: 1.15em;
  letter-spacing: .04em;
  color: var(--accent);
  user-select: none;
  .disc {
    position: relative;
    width: 2.3em;
    height: 2.3em;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 2px solid var(--accent);
    background: transparent;
    transition: background .2s ease, box-shadow .2s ease;
    svg {
      width: 1.1em;
      height: 1.1em;
      fill: var(--accent);
      transition: fill .2s ease;
    }
  }
  .count {
    min-width: 3.2em;
    text-align: left;
    font-variant-numeric: tabular-nums;
  }
  &:hover .disc {
    box-shadow: 0 0 12px var(--accent);
  }
  &.on .disc {
    background: var(--accent);
    box-shadow: 0 0 14px var(--accent);
    svg { fill: var(--accent-ink); }
  }
  &.pop .disc {
    animation: like-pop .45s ease-out;
  }
  &.pop .disc::after {
    content: '';
    position: absolute;
    inset: -2px;
    border-radius: 50%;
    border: 2px solid var(--accent);
    animation: like-ring .45s ease-out forwards;
  }
}
@keyframes like-pop {
  0%   { transform: scale(1); }
  35%  { transform: scale(1.28); }
  100% { transform: scale(1); }
}
@keyframes like-ring {
  from { transform: scale(1); opacity: .9; }
  to   { transform: scale(2); opacity: 0; }
}
@media (prefers-reduced-motion: reduce) {
  .like.pop .disc, .like.pop .disc::after { animation: none; }
}
</style>
